/* Tela Especificador já trabalhou moveis planejados */
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext, DefaultTheme } from "styled-components";
import { DataUserContext, NavigateButtonsContext } from "../..";
import { Button, Hero, LinearGradient, Back } from "../../../../components";
import { sendIfIsTheFirstPurchaseEspecificador } from "../../../../services/data-service/api";
import { Buttons, Container, Section, NavigateButtons } from "./styles";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";

const Question17: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { token } = useContext(DataUserContext);

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 17);
  }, []);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_especificador_primeira_compra.propriedades.imagens.etapa_especificador_primeira_compra_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_especificador_primeira_compra.propriedades.banner.subtituloBanner"
            )}
          />
          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_especificador_primeira_compra.propriedades.conteudo.titulo"
              )}
            </p>

            <p>
              {can(
                theme,
                "theme.steps.etapa_especificador_primeira_compra.propriedades.conteudo.subtitulo"
              )}
            </p>
            <Buttons>
              <Button
                criare
                onClick={() => {
                  sendIfIsTheFirstPurchaseEspecificador("sim", token);
                  next(18);
                }}
                icon={
                  <img
                    src={can(
                      theme,
                      "theme.steps.etapa_especificador_primeira_compra.propriedades.imagens.etapa_especificador_primeira_compra_iconeNao.url"
                    )}
                    alt=""
                  />
                }
                title={can(
                  theme,
                  "theme.steps.etapa_especificador_primeira_compra.propriedades.conteudo.texto_nao"
                )}
              />
              <Button
                criare
                onClick={() => {
                  sendIfIsTheFirstPurchaseEspecificador("nao", token);
                  next(18);
                }}
                icon={
                  <img
                    src={can(
                      theme,
                      "theme.steps.etapa_especificador_primeira_compra.propriedades.imagens.etapa_especificador_primeira_compra_iconeSim.url"
                    )}
                    alt=""
                  />
                }
                title={can(
                  theme,
                  "theme.steps.etapa_especificador_primeira_compra.propriedades.conteudo.texto_sim"
                )}
              />
            </Buttons>
          </Section>
          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question17;
